exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-privacy-and-terms-tsx": () => import("./../../../src/pages/privacy_and_terms.tsx" /* webpackChunkName: "component---src-pages-privacy-and-terms-tsx" */),
  "component---src-pages-terms-and-conditions-tsx": () => import("./../../../src/pages/terms_and_conditions.tsx" /* webpackChunkName: "component---src-pages-terms-and-conditions-tsx" */)
}

